export default {
    home:{
        'first':'中文'
    }
}